var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-view',{attrs:{"hide-navigation":""}},[_c('in-viewport',[_c('content-section',{attrs:{"widgets":_vm.detailsWidgets,"visible":_vm.visible},on:{"transitionEnd":_vm.setWidgets}})],1),_vm._v(" "),_c('in-viewport',[_c('footer-section',{attrs:{"heading":_vm.$t('info'),"team1":_vm.details.team1,"description":_vm.details.team2}})],1),_vm._v(" "),_c('in-viewport',[_c('details-pagination-container')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32622fbd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Details/DetailsContainer.vue
// module id = null
// module chunks = 